import React from 'react';
import { Button } from '@/components/ui/button';
import { LogOut, Sparkles, Shield, Cpu, AlertTriangle, TrendingDown } from 'lucide-react';

export const AdminHeader = ({ 
  view, 
  setView, 
  reportsCount = 0, 
  onLogout 
}) => {
  return (
    <header className="border-b border-stone-200 bg-white/60 backdrop-blur-md sticky top-0 z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-3 sm:py-4 flex flex-col sm:flex-row gap-3 sm:gap-0 sm:justify-between sm:items-center">
        <h1
          className="text-xl sm:text-2xl font-medium"
          style={{ fontFamily: 'Playfair Display, serif' }}
        >
          Dashboard
        </h1>
        <div className="flex items-center space-x-2 sm:space-x-4 overflow-x-auto pb-2 scrollbar-hide">
          <Button
            onClick={() => setView('metrics')}
            variant={view === 'metrics' ? 'default' : 'ghost'}
            className="rounded-full text-xs sm:text-sm whitespace-nowrap"
            size="sm"
          >
            Metrics
          </Button>
          <Button
            onClick={() => setView('users')}
            variant={view === 'users' ? 'default' : 'ghost'}
            className="rounded-full text-xs sm:text-sm whitespace-nowrap"
            size="sm"
          >
            Users
          </Button>
          <Button
            onClick={() => setView('prompts')}
            variant={view === 'prompts' ? 'default' : 'ghost'}
            className="rounded-full text-xs sm:text-sm whitespace-nowrap"
            size="sm"
          >
            <Sparkles className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
            Prompts
          </Button>
          <Button
            onClick={() => setView('moderation')}
            variant={view === 'moderation' ? 'default' : 'ghost'}
            className="rounded-full text-xs sm:text-sm whitespace-nowrap"
            size="sm"
          >
            <Shield className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
            Mod
            {reportsCount > 0 && (
              <span className="ml-1 sm:ml-2 bg-red-500 text-[#1A1A2E] text-xs px-1.5 py-0.5 rounded-full">
                {reportsCount}
              </span>
            )}
          </Button>
          <Button
            onClick={() => setView('models')}
            variant={view === 'models' ? 'default' : 'ghost'}
            className="rounded-full text-xs sm:text-sm whitespace-nowrap"
            size="sm"
            data-testid="admin-nav-models"
          >
            <Cpu className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
            Models
          </Button>
          <Button
            onClick={() => setView('churn')}
            variant={view === 'churn' ? 'default' : 'ghost'}
            className="rounded-full text-xs sm:text-sm whitespace-nowrap"
            size="sm"
            data-testid="admin-nav-churn"
          >
            <TrendingDown className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
            Churn
          </Button>
          <Button
            onClick={() => setView('danger')}
            variant={view === 'danger' ? 'default' : 'ghost'}
            className={`rounded-full text-xs sm:text-sm whitespace-nowrap ${view === 'danger' ? 'bg-red-600 hover:bg-red-700 text-white' : 'text-red-600 hover:text-red-700 hover:bg-red-50'}`}
            size="sm"
            data-testid="admin-nav-danger"
          >
            <AlertTriangle className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
            Danger
          </Button>
          <Button
            onClick={onLogout}
            variant="ghost"
            className="rounded-full"
            size="sm"
          >
            <LogOut className="w-4 h-4 sm:w-5 sm:h-5" strokeWidth={1.5} />
          </Button>
        </div>
      </div>
    </header>
  );
};
